<template>
  <BorderBox class="track-sensors-table">
    <MTable
      i18nPath="replay"
      :tableData="sensors"
      :tableColumn="tableColumn"
      :has-pagination="false"
      :showHeader="false"
      height="100%"
    />
  </BorderBox>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';
import BorderBox from '@/components/borderBox/index.vue';

export default {
  inject: ['getSensors'],
  components: {
    MTable,
    BorderBox
  },
  data() {
    return {
      tableColumn: [
        { label: '传感器名', prop: 'name' },
        {
          label: '实时数值',
          prop: 'value',
          temp({ row }) {
            return `${row.value} ${row.unitName}`;
          }
        }
      ]
    };
  },
  computed: {
    sensors() {
      return this.getSensors();
    }
  }
};
</script>

<style lang="scss">
.track-sensors-table {
  width: 100%;
  height: 55%;
  max-height: 60%;

  .m-table {
    height: 100%;
  }
  .el-table {
    background: unset !important;

    th,
    tr {
      background: inherit !important;
    }

    tr:hover > td {
      background-color: unset !important;
    }
  }
}
</style>
